/* ==========================================================================
   SheLuxe — Review section restyle
   File: assets/shx-review-init.js

   This targets Judge.me's review widget markup (class names starting with
   .jdgm-). If you ever switch review apps, the class names below will need
   to be swapped for that app's equivalents.
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
  var widget = document.querySelector('.jdgm-rev-widg');
  if (!widget) return; // Judge.me widget markup not found on this page

  /* Add an initial-letter avatar next to each reviewer's name */
  widget.querySelectorAll('.jdgm-rev__author').forEach(function (authorEl) {
    if (authorEl.dataset.shxDone) return;
    authorEl.dataset.shxDone = 'true';

    var name = authorEl.textContent.trim() || 'Anonymous';
    var initial = name.charAt(0).toUpperCase();

    var avatar = document.createElement('span');
    avatar.className = 'shx-avatar';
    avatar.textContent = initial;

    var wrapper = document.createElement('div');
    wrapper.className = 'shx-review-top';

    authorEl.parentNode.insertBefore(wrapper, authorEl);
    wrapper.appendChild(avatar);
    wrapper.appendChild(authorEl);
  });
});
